import { meadow, red, pastel } from '@/colors'

export function getScoreColor (score) {
  if (score >= 4) return meadow
  if (score >= 2) return pastel
  return red
}

export function getKindColor (kind) {
  if (kind === 'ok') return meadow
  if (kind === 'warning') return pastel
  return red
}

export function getScoreClass (score) {
  if (score >= 4) return 'ok'
  if (score >= 2) return 'warning'
  return 'danger'
}
